module.exports = __webpack_public_path__ + "img/primary_logo.4ee1e750.svg";